import React, { Fragment, useState } from "react";
import { Helmet } from "react-helmet";
import "./Auth.scss";
import next_icon from "src/assets/Next icon.svg";
import doctor from "src/assets/Doctors 05.svg";

import grid from "src/assets/grid.svg";
import signin_circle from "src/assets/signin-circle.svg";
import resend_icon from "src/assets/Resend icon.svg";
import line from "src/assets/Lines.svg";

import { Input } from "@mobiscroll/react";
import { resetPassword } from "@aws-amplify/auth";
import ResetPassword from "./ResetPassword";
import Loader from 'src/components/Dashboard/common/Loader';

function ForgotPassword() {
  const [formErrors, setFormErrors] = useState();
  const [step, setStep] = useState(1);
  const [username, setUsername] = useState("");
  const [loader, setLoader] = useState(false);

  const sendOTP = async (username) => {
    setLoader(true);

    try {
      const data = await resetPassword({ username });
      console.log("Reset password initiated successfully", data);
      setStep(2);
    } catch (err) {
      console.error(err);
      setFormErrors(err.message || "An error occurred.");
    } finally {
      setLoader(false);
    }
  }

  const nextStep = async () => {
    if (/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(username)) {
      await sendOTP(username);
    } else {
      setFormErrors("Enter Valid email address");
    }
  };

  if (step === 2) return <ResetPassword username={username} />;

  return (
    <Fragment>
      <Helmet>
        <title>Forgot Password | DOCG</title>
      </Helmet>

      <Loader show={loader} />

      <div className="mbsc-grid">
        <div className="mbsc-card main-card-wrapper">
          <div className="signup-wrapper">
            <div className="mbsc-row">
              <div className="mbsc-col-lg-6 doctor-images-left mbsc-col-12">
                <div className="left-signup-div" id="reset-password-page"></div>
                <img src={doctor} className="left-signup-img left-steps-img" />
              </div>

              <div className="mbsc-col-lg-6 mbsc-col-12 signup-right">
                <img src={grid} className="grid-top" />
                <img src={signin_circle} className="signin-circle" />
                <div className="bottom-circle" />
                <div className="top-circle" />

                <div className="right-signup-div">
                  <div className="get-started-wrapper">
                    <p className="signup-link">Step 1/2</p>
                    <p className="signup-link mt-4">Enter Username (Email) to Change Password.</p>
                    <br />

                    <div className="signup-wrapper-inner">
                      <div className="row">
                        <div className="col-12">
                          <Input
                            labelStyle="floating"
                            inputStyle="underline"
                            value={username}
                            onChange={(e) => setUsername(e.target.value)}
                          />
                        </div>
                      </div>

                      <br />

                      {formErrors ? (<span className="otp-error">{formErrors}</span>) : ("")}

                      <br />

                      <button className="purple-button" onClick={nextStep}>
                        <img src={next_icon} />&nbsp;&nbsp; Continue
                      </button>

                      <button className="purple-color mt-4">
                        <img src={resend_icon} className="resend-icon" />
                        Send me a new code
                      </button>

                    </div>
                  </div>
                </div>
                <img src={line} className="lines-bottom" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  );
}

export default ForgotPassword;
